<div class="description">
    <div class="its2-request-rfcnumber" [ngClass]="{ unread: !item.result.isRead }">
        {{ item.result.rfcNumber }}
    </div>
    <div class="its2-request-description">
        {{ item.result.shortComment }}
    </div>
    <div class="its2-request-submit">
        {{ item.result.submitDateUtc | formatShortDate9 }}
    </div>
</div>
